import { proxy } from "valtio";

const custom = proxy({
  devMode: true,
  flash: null,
  fullScreen: false,
  optionIndexPanelOpen: false,
  intro: true,
  pages: [
    "Sides",
    "Top Panel",
    "Ribs",
    "Race Number",
    "Side Logo",
    "Sealant",
    "Confirm",
  ],
  currentSeat: null,
  currentType: "Select your Bike Type",
  currentMake: { index: 0, name: "" },
  currentModel: { index: 0, name: "" },
  currentYear: { index: 0, name: "" },
  currentRibLimit: null,
  yearData: [],
  inhouseCode: "",
  modelYear: 0,
  optionPage: 0,
  topPanelSwatches: "colors",
  sidePanelMode: "regular",

  colors: [
    { name: "Black", hex: "#0F0F0F" },
    { name: "Silver", hex: "#B5B1BA" },
    { name: "Grey", hex: "#5F5D64" },
    { name: "Florescent green", hex: "#79FC3F" },
    { name: "Green", hex: "#7CD133" },
    { name: "Mint", hex: "#6CF1F5" },
    { name: "Light Blue", hex: "#54A9FD" },
    { name: "TM Blue", hex: "#2151FA" },
    { name: "Blue", hex: "#0F05B7" },
    { name: "KTM Blue", hex: "#1C1E37" },
    { name: "Purple", hex: "#A927F8" },
    { name: "Maroon", hex: "#711616" },
    { name: "Red", hex: "#F62F29" },
    { name: "Bright Red", hex: "#F93522" },
    { name: "Orange", hex: "#F77321" },
    { name: "Pink", hex: "#FF5AB5" },
    { name: "Bright Yellow", hex: "#FEE640" },
    { name: "Gold Yellow", hex: "#FED750" },
    { name: "Yellow", hex: "#FADB2E" },
    { name: "Neon Yellow", hex: "#E5FF1A" },
    { name: "White", hex: "#F5F5F5" },
    { name: "Checker", src: "checker" },
    { name: "Houndstooth", src: "houndstooth" },
    { name: "Jungle Camo", src: "junglecamo" },
    { name: "Desert", src: "desert" },
    { name: "Neon Yellow Bolt", src: "neonyellowbolt" },
    { name: "Neon Blue Techno", src: "neonbluetechno" },
    { name: "Aloha", src: "aloha" },
    { name: "Cheetah", src: "cheetah" },
    { name: "Serape", src: "serape" },
    // { name: "Whiteplain", src: "whiteplain" },
  ],

  reinforcedColors: [
    { name: "Black", hex: "#0F0F0F" },
    // { name: "Black", hex: "#332F21" },
    { name: "Blue", hex: "#0F05B7" },
    { name: "Red", hex: "#F62F29" },
  ],
  colorsExcPatterns: 21,
  colorWhite: "#F3F3F3",
  selectedTopPanel: { name: "White", hex: "#ddd", src: null },
  selectedSidePanels: { name: "White", hex: "#ddd" },
  selectedMidPanels: { name: "White", hex: "#ddd", src: null },
  selectedSingleRibs: { name: "White", hex: "#ddd", src: null },
  selectedMultiRib1: { name: "White", hex: "#ddd", src: null },
  selectedMultiRib2: { name: "White", hex: "#ddd", src: null },
  selectedMultiRib3: { name: "White", hex: "#ddd", src: null },
  selectedMultiRib4: { name: "White", hex: "#ddd", src: null },
  selectedMultiRib5: { name: "White", hex: "#ddd", src: null },
  selectedMultiRib6: { name: "White", hex: "#ddd", src: null },
  selectedMultiRib7: { name: "White", hex: "#ddd", src: null },
  selectedMultiRib8: { name: "White", hex: "#ddd", src: null },
  selectedStitchColor: { name: "black", hex: "#000" },
  ribColorMode: "single",
  ribLimit: 0,
  ribPanelSwatches: "colors",
  // selectedRibColor: [
  //   { name: "Start", hex: "#dddddd" },
  //   { name: "Start", hex: "#dddddd" },
  //   { name: "Start", hex: "#dddddd" },
  //   { name: "Start", hex: "#dddddd" },
  //   { name: "Start", hex: "#dddddd" },
  //   { name: "Start", hex: "#dddddd" },
  //   { name: "Start", hex: "#dddddd" },
  // ],
  ribMultiSelected: 1,
  currentRib: 1,
  initialCameraPosition: [2.25, 1, 2.25],
  initialCameraTarget: [0, 0, 0],
  urrentCameraTarget: [-3.25, -1, -3.25],
  cameraTargetLogo: [3, 3, 3],
  currentCameraMode: "FREE",
  raceNumberMode: "none",
  numberSelectMode: "number",
  raceNumber: "",
  raceNumberColor: { name: "White", hex: "#dddddd" },
  raceNumberFont: "old-english.ttf",
  selectedFont: "helvetica",
  fonts: ["impact", "hauser", "comicSans", "oldEnglish"],
  stitchColorMode: "no",
  sideLogoMode: "enjoyMfg",
  sealantMode: "no",
  message: "",
  customizeModelChoice: false,
  modalOpen: false,
  pendingTransaction: true,
  productBeingAdded: false,
  processingTransaction: false,
  instructionsVisible: false,
  modalResetCustomisationOpen: false,
  exitAppOpen: false,
  cameraControlsOpen: false,
  settingModelType: false,
  settingModel: true,
  modalDisclaimerOpen: false,
  settingMultiRibs: false,
  settingNumber: false,
  termsChecked: false,
  terms2Checked: false,
  confirmResetRibs: false,
  confirmRemoveNumber: false,
  confirmLeave: false,
  confirmReset: false,
  confirmRepick: false,
  cameraControls: {
    position: [3.5, 1, 1],
    target: [0, 0, 0],
    fov: 10,
    // static: false,
  },
  autoCamera: true,
  cartContentsOpen: false,
  cartContentNumber: 0,
  basePrice: {
    motorcycle: 58.95,
    atv: 64.95,
  },
  addonPrice: {
    reinforcedSides: 9.95,
    number: 9.95,
    sealant: 23,
    ribs: 10,
  },
});

export { custom };

// cameraPosition: [1.5, .3 , 1.5]
